<tangy-select (change)="onSelect()" #selectElement>
</tangy-select>